module.exports = __webpack_public_path__ + "fonts/fa-regular-400.ef60a4f6.woff";